import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import TodoList from "./pages/TodoList";

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
   

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/todos" element={<TodoList />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
